import { useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { CompanyTitledPage } from "../../TitledPage";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { green, grey, yellow } from "@mui/material/colors";

import { getDisplaySize } from "../../../utils/Items";
import { decimalToPercentDecimal, getHyphenedDate, inputValueToDecimal, inputValueToInt, percentDecimalToDecimal } from "../../../utils/utils";

import { InputAdornment, Switch, TextField } from "@mui/material";
import { SYSTEM_PATH_COMPANY } from "../../../App";
import {
  MSG_ERR_MARKET_PRICE_INCORRECT,
  MSG_ERR_SHIPPING_DATE_NOT_ENTERED,
  MSG_ERR_SHIPPING_DATE_NOT_FOUND,
  MSG_ERR_UNEXPECTED,
} from "../../../common/message";
import { MinusButton, PlusButton } from "../../../components/Buttons";
import DateInput from "../../../components/DateInput";
import AddProductMasterDialog from "../../../components/dialog/addProductMasterDialog/AddProductMasterDialog";
import AddProductDetailMasterDialog from "../../../components/dialog/addProductDetailMasterDialog/AddProductDetailMasterDialog";
import AddProductDialog from "../../../components/dialog/addProductDialog/AddProductDialog";
import ErrorMessageBox from "../../../components/ErrorMessageBox";
import { DecimalFormControl, IntegerFormControl } from "../../../components/FormControl";
import DeleteProductDialog from "../../product/DeleteProductDialog";
import { postMarketCalendarSearchNextOpenDateInfoAPI } from "../../../http/api/MarketCalendarAPI";
import {
  postMarketPriceSearchHistoryInShippingDates,
  postMarketPriceSearchInfoListAPI,
  postMarketPriceSearchTableInfoListAPI,
  postMarketPriceUpdateHistoryInfoAPI,
} from "../../../http/api/MarketPriceAPI";
import { getActualShippingDateInfo } from "../../../utils/shippingDate";
import { getDeliveryPriceCalculation, getPrimePrice, getSellingPrice, getUsingDeliveryPrice } from "../../../utils/orderForm";
import Decimal from "decimal.js";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { confirmWhenChanged } from "../../../utils/validation";
import { flushSync } from "react-dom";
import { getLoginUserInfo } from "../../../utils/loginUser";

// 価格表の行の最大数
const maxPriceTableRows = 20;

// 価格表カラム名
const priceTableColumnNames = {
  display_order: "No",
  name: "商品",
  place: "産地",
  other_place: "他",
  size: "発注規格",
  market_price: "市況価格",
  imformed_price: "案内価格",
  prime_price_mark_up_rate: "原価\n値入率",
  prime_price: "原価",
  selling_price_mark_up_rate: "売価\n値入率",
  selling_price: "売価",
  delivery_price: "納品価格",
  unit_price_per_kilo: "キロ単価",
  basic_price: "基本\n価格",
  unit: "発注単位",
  is_shortage: "入荷\n未定",
  market_display: "表示",
  remarks: "備考",
};

const priceTableColumnSx = {
  fontSize: 18,
};

// 注文票確認遷移state取得
const getOrderFormConfirmLocationState = (marketPriceId, marketPriceHistoryDate) => ({
  marketPriceId, marketPriceHistoryDate
});

// テキストボックス　フォーカス時に全選択する
const onFocusInput = (event) => {
  event.target.select();
};

// 入力ボックス　最後の％
function InputPercentAdornment() {
  return <InputAdornment position="end">%</InputAdornment>;
};

// 表のデータ行1行分
function PriceTableRow({
  data,
  updateData,
  onClickAddProduct,
  onClickDeleteProduct,
  index,
  focusNavigation
}) {
  const updateDataInput = (prop, value) => {
    updateData(data.infoListIndex, prop, value);
  };

  const setPriceValueInput = (value) => {
    updateDataInput("marketPriceInput", value);
  };

  const setValidation = (isValid) => {
    updateDataInput("validation", isValid);
  };
  
  const setPrimePriceMarkUpRatePercentageInput = (value) => {
    updateDataInput("primePriceMarkUpRatePercentageInput", value);
  };

  const setSellingPriceMarkUpRatePercentageInput = (value) => {
    updateDataInput("sellingPriceMarkUpRatePercentageInput", value);
  };

  const onChangeIsCustomerOrder = (event) => {
    updateDataInput("isCustomerOrder", event.target.checked);
  };

  const setRemarksInput = (value) => {
    updateDataInput("remarks", value);
  };

  const onChangeIsOriginOther = (event) => {
    updateDataInput("isOriginOther", event.target.checked);
  };

  const onChangeIsShortage = (event) => {
    updateDataInput("isShortage", event.target.checked);
  };

  var basePriceDisplay = "-";

  if (data.isShortage) {
    basePriceDisplay = "欠品";
  } else if (data.basePrice) {
    basePriceDisplay = data.basePrice;
  }

  const [focusing, setFocusing] = useState({
    tab: 1,
    item: "marketPriceInput",
    index: -1,
  });

  function HandleFocus(event) {
    let id = event.target.id;
    let element = id.split("-");
    let tab = element[0];
    let cell = element[1];

    let patt1 = /[a-zA-Z]/g;
    let patt2 = /[0-9]/g;
    let letters = cell.match(patt1).join("");
    let digits = parseInt(cell.match(patt2).join(""));
    // let digits = parseInt(str.match(/[0-9]+$/));
    // let letters = str.substr(0, str.length - digits.length);
    setFocusing({ tab, item: letters, index: digits });

    //行を黄色く塗る
    ChangeColorRow(event.target,yellow[100]);
  }

  function HandleBlur(event) {
    //行を黄色く塗る
    ChangeColorRow(event.target,"inherit");
  }

  function ChangeColorRow(target,color){
    let parentElement = target.parentNode;
    while (parentElement && parentElement.tagName !== "TR") {
      parentElement = parentElement.parentNode;
    }
    parentElement.style.backgroundColor = color;
  }

  function HandlePressKey(event) {
    if (event.ctrlKey) {
      console.log(event);
      event.preventDefault();
      updateDataInput(`isOriginOther`, !data.isOriginOther);
      // FocusNavigation();
    }
    if (event.key === "Enter") {
      event.preventDefault();
      event.target.blur();
      focusNavigation(focusing, event.shiftKey);
    }
  }

  function HandleKeyDown(event) {
    // console.log(event);
    if (event.ctrlKey) {
      if (event.key === "+") {
        event.preventDefault();
        document
          .getElementById(`${focusing.tab}-btnAddProduct${focusing.index}`)
          .click();
      }
      if (event.key === "-") {
        event.preventDefault();
        document
          .getElementById(`${focusing.tab}-btnDeleteProduct${focusing.index}`)
          .click();
      }
      if (event.key === "g") {
        event.preventDefault();
        updateDataInput(`isOriginOther`, !data.isOriginOther);
      }
      if (event.key === "h") {
        event.preventDefault();
        updateDataInput(`isCustomerOrder`, !data.isCustomerOrder);
        focusNavigation(focusing);
      }
      if (event.key === "k") {
        event.preventDefault();
        updateDataInput(`isShortage`, !data.isShortage);
        focusNavigation(focusing);
      }
    }

    if (event.key === "ArrowUp") {
      event.preventDefault();
      event.target.blur();
      focusNavigation(focusing, true);
    }
    if (event.key === "ArrowDown") {
      event.preventDefault();
      event.target.blur();
      focusNavigation(focusing, false);
    }
  }
  
  // 原価・売価の表示取得
  var displayPrimePrice = 0;
  var displaySellingPrice = 0;

  if (data.isUsingSellingPrice) {
    displayPrimePrice = getPrimePrice(
      (data.isUsingDeliveryPrice ? data.getDeliveryPrice(inputValueToInt(data.marketPriceInput), data.deliveryPriceAdditionAmount) : inputValueToInt(data.marketPriceInput)),
      percentDecimalToDecimal(inputValueToDecimal(data.primePriceMarkUpRatePercentageInput))
    ).toLocaleString();
  
    displaySellingPrice = getSellingPrice(
      (data.isUsingDeliveryPrice ? data.getDeliveryPrice(inputValueToInt(data.marketPriceInput), data.deliveryPriceAdditionAmount) : inputValueToInt(data.marketPriceInput)),
      percentDecimalToDecimal(inputValueToDecimal(data.primePriceMarkUpRatePercentageInput)),
      percentDecimalToDecimal(inputValueToDecimal(data.sellingPriceMarkUpRatePercentageInput))
    ).toLocaleString();
  }

  // 納品価格の表示取得
  var displayDeliveryPrice = 0;
  if (data.isUsingDeliveryPrice) {
    displayDeliveryPrice = data.getDeliveryPrice(inputValueToInt(data.marketPriceInput), data.deliveryPriceAdditionAmount);
  }

  return (
    <TableRow
      onFocus={HandleFocus}
      onBlur={HandleBlur}
      onKeyPress={HandlePressKey}
      onKeyDown={HandleKeyDown}
      sx={{backgroundColor : data.isCustomerOrder ? "inherit" : grey[300]}}
    >
      <TableCell sx={{ ...priceTableColumnSx }}>{data.displayOrder}</TableCell>
      <TableCell
        component="th"
        scope="row"
        sx={{
          ...priceTableColumnSx,
          fontWeight: "bold",
          fontSize: 20,
          height: 28,
          width: "15%",
          padding: 1,
        }}
      >
        {data.displayName}
      </TableCell>
      <TableCell sx={{ ...priceTableColumnSx, width: "8%" }}>
        {data.displayOrigin}
      </TableCell>
      <TableCell sx={{ ...priceTableColumnSx, width: "3%" }}>
        <Checkbox
          onChange={onChangeIsOriginOther}
          checked={data.isOriginOther}
          id={`${data.priceDetailTypeId}-isOriginOther${index}`}
        />
      </TableCell>
      <TableCell sx={{ ...priceTableColumnSx, width: "15%" }}>
        {data.displaySize}
      </TableCell>
      <TableCell
        sx={{ ...priceTableColumnSx, padding: 1, width: 100 }}
        onFocus={HandleFocus}
      >
        <IntegerFormControl
          value={data.marketPriceInput}
          setValue={setPriceValueInput}
          setValid={setValidation}
          disabled={data.isShortage || !data.isCustomerOrder}
          inputProps={{ sx: { ...priceTableColumnSx, textAlign: "right" } }}
          inputSx={{ width: 100 }}
          helperTextSx={{ margin: 0, width: 100 }}
          id={`${data.priceDetailTypeId}-marketPriceInput${index}`}
        />
      </TableCell>
      {
        data.isUsingSellingPrice
        ? (
          <>
            <TableCell
              sx={{ ...priceTableColumnSx, padding: 1, width: 100 }}
              onFocus={HandleFocus}
            >
              <DecimalFormControl
                value={data.primePriceMarkUpRatePercentageInput}
                setValue={setPrimePriceMarkUpRatePercentageInput}
                setValid={setValidation}
                disabled={data.isShortage || !data.isCustomerOrder}
                fixed={2}
                inputProps={{ sx: { ...priceTableColumnSx, textAlign: "right" } }}
                inputSx={{ width: 100 }}
                endAdornment={<InputPercentAdornment />}
                helperTextSx={{ margin: 0, width: 100 }}
                id={`${data.priceDetailTypeId}-primePriceMarkUpRatePercentageInput${index}`}
              />
            </TableCell>
            <TableCell sx={{ ...priceTableColumnSx, width: "8%", textAlign: 'right' }}>
              {displayPrimePrice}
            </TableCell>
            <TableCell
              sx={{ ...priceTableColumnSx, padding: 1, width: 100 }}
              onFocus={HandleFocus}
            >
              <DecimalFormControl
                value={data.sellingPriceMarkUpRatePercentageInput}
                setValue={setSellingPriceMarkUpRatePercentageInput}
                setValid={setValidation}
                disabled={data.isShortage || !data.isCustomerOrder}
                fixed={2}
                inputProps={{ sx: { ...priceTableColumnSx, textAlign: "right" } }}
                inputSx={{ width: 100 }}
                endAdornment={<InputPercentAdornment />}
                helperTextSx={{ margin: 0, width: 100 }}
                id={`${data.priceDetailTypeId}-sellingPriceMarkUpRatePercentageInput${index}`}
              />
            </TableCell>
            <TableCell sx={{ ...priceTableColumnSx, width: "8%", textAlign: 'right' }}>
              {displaySellingPrice}
            </TableCell>
          </>
        ) : null
      } {
        data.isUsingDeliveryPrice
        ? <TableCell sx={{...priceTableColumnSx, width: "8%", textAlign: "right"}}>{data.isShortage ? "-" : displayDeliveryPrice.toLocaleString() }</TableCell>
        : null
      } {/* <TableCell
        sx={{
          ...priceTableColumnSx,
          backgroundColor: green[50],
          textAlign: "right",
        }}
      >
        {basePriceDisplay.toLocaleString()}
      </TableCell> */}
      <TableCell sx={{ ...priceTableColumnSx }}>{data.orderingUnit}</TableCell>
      <TableCell sx={{ padding: 1 }}>
        <Checkbox
          onChange={onChangeIsShortage}
          checked={data.isShortage}
          id={`${data.priceDetailTypeId}-isShortage${index}`}
        />
      </TableCell>
      <TableCell sx={{ padding: 1 }}>
        <Checkbox
          onChange={onChangeIsCustomerOrder}
          checked={data.isCustomerOrder}
          id={`${data.priceDetailTypeId}-isCustomerOrder${index}`}
        />
      </TableCell>
      <TableCell sx={{ ...priceTableColumnSx, padding: 1, width: 100 }}>
        <TextField
          value={data.remarks}
          onChange={(e) => setRemarksInput(e.target.value)}
          disabled={!data.isCustomerOrder}
          sx={{width: 100}}
          id={`${data.priceDetailTypeId}-remarks${index}`}
        ></TextField>
      </TableCell>
      <TableCell sx={{ padding: 1 }}>
        <PlusButton
          onClick={onClickAddProduct(data)}
          id={`${data.priceDetailTypeId}-btnAddProduct${index}`}
        />
      </TableCell>
      <TableCell sx={{ padding: 1 }}>
        <MinusButton
          onClick={onClickDeleteProduct(data)}
          id={`${data.priceDetailTypeId}-btnDeleteProduct${index}`}
        />
      </TableCell>
    </TableRow>
  );
}

// 価格表(編集用)
function PriceEditTable({
  dataList,
  updateData,
  onClickAddProduct,
  onClickDeleteProduct,
  priceTableSetting,
  focusNavigation
}) {
  
  // 単価列名出力設定
  const getUnitColumnName = (priceTableSetting) => {
    if (priceTableSetting.isUsingDeliveryPrice) {
      return priceTableColumnNames.imformed_price;
    }

    return priceTableSetting.unitPriceCd === 2 ? priceTableColumnNames.unit_price_per_kilo : priceTableColumnNames.market_price
  }

  var lastName = "";
  var lastOrigin = "";

  if (dataList && dataList.length > 0) {
    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.display_order}
              </TableCell>
              <TableCell
                sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.name}
              </TableCell>
              <TableCell
                sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.place}
              </TableCell>
              <TableCell
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  whiteSpace: "pre-wrap",
                }}
              >
                {priceTableColumnNames.other_place}
              </TableCell>
              <TableCell
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  whiteSpace: "pre-wrap",
                }}
              >
                {priceTableColumnNames.size}
              </TableCell>
              <TableCell
                sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
              >
                {getUnitColumnName(priceTableSetting)}
              </TableCell>
              {
                priceTableSetting.isUsingSellingPrice
                ? (
                  <>
                    <TableCell
                      sx={{ ...priceTableColumnSx, whiteSpace: "pre-wrap", backgroundColor: grey[100] }}
                    >
                      {priceTableColumnNames.prime_price_mark_up_rate}
                    </TableCell>
                    <TableCell
                      sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
                    >
                      {priceTableColumnNames.prime_price}
                    </TableCell>
                    <TableCell
                      sx={{ ...priceTableColumnSx, whiteSpace: "pre-wrap", backgroundColor: grey[100] }}
                    >
                      {priceTableColumnNames.selling_price_mark_up_rate}
                    </TableCell>
                    <TableCell
                      sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
                    >
                      {priceTableColumnNames.selling_price}
                    </TableCell>
                  </>
                ) : null
              } {
                priceTableSetting.isUsingDeliveryPrice       
                  ? <TableCell rowSpan={2} sx={{...priceTableColumnSx, backgroundColor: grey[100], whiteSpace: 'pre-wrap', width: "8%"}}>{priceTableColumnNames.delivery_price}</TableCell>
                  : null
              } {/* <TableCell
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: green[100],
                  whiteSpace: "pre-wrap",
                }}
              >
                {priceTableColumnNames.basic_price}
              </TableCell> */}
              <TableCell
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  whiteSpace: "pre-wrap",
                }}
              >
                {priceTableColumnNames.unit}
              </TableCell>
              <TableCell
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  whiteSpace: "pre-wrap",
                }}
              >
                {priceTableColumnNames.is_shortage}
              </TableCell>
              <TableCell
                sx={{
                  ...priceTableColumnSx,
                  backgroundColor: grey[100],
                  whiteSpace: "pre-wrap",
                }}
              >
                {priceTableColumnNames.market_display}
              </TableCell>
              <TableCell
                sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
              >
                {priceTableColumnNames.remarks}
              </TableCell>
              <TableCell
                sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
              >
                追加
              </TableCell>
              <TableCell
                sx={{ ...priceTableColumnSx, backgroundColor: grey[100] }}
              >
                削除
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataList.map((data, i) => {
              let displayData = {
                ...data,
                displayName:
                  lastName === data.productName ? "" : data.productName,
                displayOrigin:
                  lastName === data.productName && lastOrigin === data.origin
                    ? ""
                    : data.origin,
              };

              lastName = data.productName;
              lastOrigin = data.origin;

              return (
                <PriceTableRow
                  data={displayData}
                  updateData={updateData}
                  onClickAddProduct={onClickAddProduct}
                  onClickDeleteProduct={onClickDeleteProduct}
                  key={"marketPrice_" + i.toString()}
                  index={i}
                  focusNavigation={focusNavigation}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return null;
}

// 価格表タブの内容
function PriceTableTabContent({
  dataList,
  updateDataList,
  onClickAddProduct,
  onClickDeleteProduct,
  tabPosition,
  priceTableSetting
}) {
  const [page, setPage] = useState(1);

  const updateData = (basePriceDetailId, prop, value) => {
    updateDataList(basePriceDetailId, prop, value);
  };

  const handleChangeTablePage = (event, page_num) => {
    setPage(page_num);
  };

  var dataMinIndex = (page - 1) * maxPriceTableRows;

  var tableData = dataList.slice(
    dataMinIndex,
    Math.min(dataMinIndex + maxPriceTableRows, dataList.length)
  );

  // 次にフォーカスを当てる要素を指定
  async function focusNavigation(currentFocusing, isPrevious = false) {

    const step = isPrevious ? -1 : 1;

    const {tab: currentTab, item: currentItem, index: currentIndex} = currentFocusing;
    const currentIndexInList = dataMinIndex + currentIndex;

    const focusableDatas
      = dataList
        .map((data, i) => ({...data, dataIndex: i * step}))
        .filter((data) => (
          (data.dataIndex - currentIndexInList * step) > 0
            && !(currentItem == 'marketPriceInput' && (data.isShortage || !data.isCustomerOrder))
            && !(currentItem == 'sellingPriceMarkUpRatePercentageInput' && (data.isShortage || !data.isCustomerOrder))
            && !(currentItem == 'remarks' && (!data.isCustomerOrder))
        )).sort((data1, data2) => data1.dataIndex - data2.dataIndex);  
    
    if (focusableDatas.length == 0) {
      return;
    }

    const focusableDataIndex = focusableDatas[0].dataIndex / step;
    const focusPage = Math.floor(focusableDataIndex / maxPriceTableRows) + 1;
    const focusRowInTable = focusableDataIndex % maxPriceTableRows;

    flushSync(() => {
      setPage(focusPage);
    });
    
    document.getElementById(
      `${currentTab}-${currentItem}${focusRowInTable}`
    ).focus();

  }

  const handleKeyDownPaging = useCallback(
    (e) => {
      if (e.ctrlKey) {
        if (e.key === "ArrowLeft") {
          e.preventDefault();
          e.target.blur();
          if (page > 1) {
            setPage(prevValue=>prevValue - 1);
          }
          console.log("move page");
        }
        if (e.key === "ArrowRight") {
          e.preventDefault();
          e.target.blur();
          if (page < Math.ceil(dataList.length / maxPriceTableRows)) {
            setPage(prevValue=>prevValue + 1);
          }
          console.log("move page");
        }
      }
    },
    [page, dataList]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDownPaging);
    return () => {
      document.removeEventListener("keydown", handleKeyDownPaging);
    };
  }, [handleKeyDownPaging]);

  useEffect(() => {
    setPage(1);
    console.log("page change");
    //TODO React18のバッチアップデートを除く
    setTimeout(() => {
      try {
        //ページ１をクリック
        let listPagingButton =
          document.getElementById(`paging`).children[0].children;
        listPagingButton[1].children[0].click();

        //一番上対象にフォカス
        let topItem = `${tabPosition}-marketPriceInput0`;
        document.getElementById(topItem).focus();
      } catch {}
    }, 100);
  }, [tabPosition]);

  return (
    <Box>
      <Grid container spacing={2} marginBottom={2}>
        <Grid item xs={12}>
          <PriceEditTable
            dataList={tableData}
            updateData={updateData}
            onClickAddProduct={onClickAddProduct}
            onClickDeleteProduct={onClickDeleteProduct}
            priceTableSetting ={priceTableSetting}
            focusNavigation={focusNavigation}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <Pagination
            count={Math.ceil(dataList.length / maxPriceTableRows)}
            page={page}
            variant="outlined"
            shape="rounded"
            onChange={handleChangeTablePage}            
            sx={{ display: "inline-block" }}
            id={`paging`}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

// 市況価格表編集ページ
export default function MarketPriceEditPage() {
  const location = useLocation();
  var initMarketPriceId = location.state ? location.state.marketPriceId : 1;
  var initShippingDateInfo = location.state ? location.state.shippingDateInfo : null;
  var initMarketPriceHistoryDate = location.state ? location.state.marketPriceHistoryDate : null;
  var orderFormConfirmIsInit = location.state ? location.state.isInitial : true;

  var initShippingDateFrom = initShippingDateInfo ? initShippingDateInfo.shippingDateFrom : null;
  var initShippingDateTo = initShippingDateInfo ? initShippingDateInfo.shippingDateTo : null;

  const navigate = useNavigate();

  const [tableTabPosition, setTableTabPosition] = useState(1);

  const [marketPriceTableInfo, setMarketPriceTableInfo] = useState(null);
  const [marketPriceInfoList, setMarketPriceInfoList] = useState([]);

  const [shippingDateInput, setShippingDateInput] = useState({
    dateFrom: "",
    dateTo: "",
    isValidInterval: false,
    initialized: false,
    cleared: false,
  });

  const [dialogMode, setDialogMode] = useState(0);

  const [selectedProductData, setSelectedProductData] = useState({
    marketPriceDetailId: 0,
    productName: "",
    origin: "",
    rank: "",
    productClass: "",
    weight: "",
    weightUnit: "",
    orderingUnit: "",
    basePrice: 0,
    marketPrice: 0,
    infoListIndex: 0,
    displayOrder: 1,
  });

  // 市況価格表更新中をあらわすstate
  const [isUpdating, setUpdating] = useState(false);
  // 画面ステータスをcontextから取得
  const {isChanged, setChanged} = useContext(ScreenStatusContext);

  const getPriceTabDataList = (dataList, tabPosition) => {
    return dataList
      .filter(
        (data) => data.priceDetailTypeId === tabPosition && !data.isDelete
      )
      .sort(compareDataByDisplayOrder);
  };

  useEffect(() => {
    (async () => {

      if (initMarketPriceId) {
        let marketPriceTableRes = await postMarketPriceSearchTableInfoListAPI({marketPriceId: initMarketPriceId, marketPriceHistoryDate: orderFormConfirmIsInit ? null : initMarketPriceHistoryDate});

        let initMarketPriceTableInfo = marketPriceTableRes.marketPriceTableInfoList[0];

        setMarketPriceTableInfo({
          ...initMarketPriceTableInfo,
          marketPriceHistoryDate: initMarketPriceHistoryDate,
          primePriceMarkUpRate: initMarketPriceTableInfo.isUsingSellingPrice ? new Decimal(initMarketPriceTableInfo.primePriceMarkUpRate) : null,
          sellingPriceMarkUpRate: initMarketPriceTableInfo.isUsingSellingPrice ? new Decimal(initMarketPriceTableInfo.sellingPriceMarkUpRate) : null,
        });

        // 出荷日取得・保持
        initializeShippingDate(initShippingDateFrom, initShippingDateTo, initMarketPriceTableInfo.shippingDateInitialSetting);

        let priceInfoList = await getMarketPriceInfoList(initMarketPriceId, initMarketPriceHistoryDate, initMarketPriceTableInfo);
        setMarketPriceInfoList(priceInfoList);
        setTableTabPosition(getInitialTableTabPosition(priceInfoList));
      }
    })();
  }, []);

   // 出荷日を初期化する
   const initializeShippingDate = async (initDateFrom, initDateTo, shippingDateInitialSettingCd) => {

    let isValidInterval = true;
    let dateFrom = '';
    let dateTo = '';

    let todayDateStr = getHyphenedDate(new Date());

    if ((initDateFrom && initDateFrom > todayDateStr)
        || (initDateTo && initDateTo > todayDateStr)) {
      dateFrom = initDateFrom;
      dateTo = initDateTo;
    } else {

      let nextOpenDateRes = await postMarketCalendarSearchNextOpenDateInfoAPI({});
      let nextOpenDateInfo = nextOpenDateRes.nextOpenDateInfo; 

      if (nextOpenDateInfo) {
        dateFrom = nextOpenDateInfo.nextOpenDate;
        if (shippingDateInitialSettingCd === 2) {
          dateTo = nextOpenDateInfo.nextOpenDate
        }
      }
    }

    if (!dateTo) {
      dateTo = dateFrom;
      isValidInterval = false;
    } else if (!dateFrom){
      dateFrom = dateTo;
      isValidInterval = false;
    }

    setShippingDateInput({
      ...shippingDateInput,
      dateFrom: dateFrom,
      dateTo: dateTo,
      isValidInterval: isValidInterval,
      initialized: true
    });
  }
  
  const getMarketPriceInfoList = async (marketPriceId, marketPriceHistoryDate, marketPriceTableInfo) => {
    try {
      let marketPriceRes = await postMarketPriceSearchInfoListAPI({
        marketPriceId, marketPriceHistoryDate
      });

      return marketPriceRes.marketPriceInfoList.map((data, index) => ({
        ...data,
        displaySize: getDisplaySize(
          data.rank,
          data.productClass,
          data.weight,
          data.weightUnit,
          data.packing,
          data.quantity
        ),
        marketPriceInput: data.marketPrice.toLocaleString(),
        isUsingSellingPrice: marketPriceTableInfo.isUsingSellingPrice,
        primePriceMarkUpRatePercentageInput: marketPriceTableInfo.isUsingSellingPrice ? decimalToPercentDecimal(new Decimal(data.primePriceMarkUpRate || marketPriceTableInfo.primePriceMarkUpRate)).toFixed(2) : '',
        sellingPriceMarkUpRatePercentageInput: marketPriceTableInfo.isUsingSellingPrice ? decimalToPercentDecimal(new Decimal(data.sellingPriceMarkUpRate || marketPriceTableInfo.sellingPriceMarkUpRate)).toFixed(2) : '',
        isUsingDeliveryPrice: getUsingDeliveryPrice(marketPriceTableInfo.deliveryPriceAdditionCd),
        getDeliveryPrice: getDeliveryPriceCalculation(marketPriceTableInfo.deliveryPriceAdditionCd),
        deliveryPriceAdditionAmount : marketPriceTableInfo.deliveryPriceAdditionAmount,
        validation: true,
        isDelete: false,
        isChanged: false,
        infoListIndex: index,
      }));
    } catch (err) {
      if (err.response.data != "dataNotExist") {
        alert(MSG_ERR_UNEXPECTED);
      }

      return [];
    }
  };

  // 市況価格表データ取得後の初期タブ位置を取得する
  const getInitialTableTabPosition = (priceInfoList) => {
    if (
      priceInfoList.length === 0 ||
      priceInfoList.some((productData) => productData.priceDetailTypeId === 1)
    ) {
      return 1;
    }
    if (
      priceInfoList.some((productData) => productData.priceDetailTypeId === 2)
    ) {
      return 2;
    }
    return 3;
  };

  const getErrorMessages = () => {
    let msgs = [];

    if (shippingDateInput.initialized
      && shippingDateInput.dateFrom.length === 0
      && shippingDateInput.dateTo.length === 0
    ) {
      if (shippingDateInput.cleared) {
        msgs.push(MSG_ERR_SHIPPING_DATE_NOT_ENTERED);
      } else {
        msgs.push(MSG_ERR_SHIPPING_DATE_NOT_FOUND);
      }
    }

    if (marketPriceInfoList.some((productData) => !productData.isDelete && !productData.validation)) {
      msgs.push(MSG_ERR_MARKET_PRICE_INCORRECT);
    }

    return msgs;
  };

  const handleChangeTab = (event, tabPos) => {
    setTableTabPosition(tabPos);
  };

  // 出荷日期間指定スイッチ変更
  const onChangeShippingDateValidInterval = (event, isValidInterval) => {
    setShippingDateInput({...shippingDateInput, isValidInterval});
  }

  // 出荷日期間変更
  const updateShippingDateInterval = (prop) => (date) => {
    let newShippingDateInput = {...shippingDateInput};
    let valueChanged = shippingDateInput[prop] !== date;

    newShippingDateInput[prop] = date
    setShippingDateInput(newShippingDateInput);
    setChanged(isChanged || valueChanged);
  }

  // 商品情報更新
  const updateDataList = (infoListIndex, prop, value) => {
    let newDataList = [...marketPriceInfoList];
    let marketPriceData = newDataList[infoListIndex];
    let valueChanged = marketPriceData[prop] !== value;

    marketPriceData[prop] = value;
    marketPriceData.isChanged = true;

    setMarketPriceInfoList(newDataList);
    setChanged(isChanged || valueChanged);
  };

  // 商品追加ダイアログを開く
  const openAddProductDialog = (productData) => {
    setSelectedProductData(productData);
    setDialogMode(1);
  };

  // 商品追加ボタン押下時処理
  const onClickAddProduct = (productData) => (event) => {
    openAddProductDialog({
      productId: productData ? productData.productId : 0,
      productName: productData ? productData.productName : "",
      marketPrice: 0,
      displayOrder: productData ? productData.displayOrder : 0
    });
  };

  // 商品追加ダイアログを閉じる処理
  const onCloseDialog = (event) => {
    setDialogMode(0);
  };

  // 商品を追加する処理
  const addProduct = (productData, part, price, displayOrder) => {
    const {
      productId,
      productDetailId,
      productName,
      origin,
      displaySize,
      unit,
    } = productData;

    let insertIndex = marketPriceInfoList.findIndex(
      (productInfo, index) =>
        (productInfo.priceDetailTypeId == part &&
          productInfo.displayOrder >= displayOrder) ||
        productInfo.priceDetailTypeId > part
    );

    var insertBeforeList =
      insertIndex >= 0
        ? marketPriceInfoList.slice(0, insertIndex)
        : marketPriceInfoList;

    var insertAfterList = (
      insertIndex >= 0 ? marketPriceInfoList.slice(insertIndex) : []
    ).map((productData) => ({
      ...productData,
      infoListIndex: productData.infoListIndex + 1,
      displayOrder:
        productData.priceDetailTypeId == part
          ? productData.displayOrder + 1
          : productData.displayOrder,
      isChanged: true,
    }));

    var insertDisplayOrder =
      insertBeforeList
        .filter(
          (productData) =>
            productData.priceDetailTypeId == part && !productData.isDelete
        )
        .map((productData) => productData.displayOrder)
        .reduce((a, b) => Math.max(a, b), 0) + 1;

    const newMarketPriceInfo = {
      ...productData,
      marketPriceId: marketPriceTableInfo.marketPriceId,
      priceDetailTypeId: part,
      marketPrice: price,
      rank: displaySize,
      isShortage: false,
      isOriginOther: false,
      marketPriceInput: price.toLocaleString(),
      isUsingSellingPrice: marketPriceTableInfo.isUsingSellingPrice,
      primePriceMarkUpRatePercentageInput: marketPriceTableInfo.isUsingSellingPrice ? decimalToPercentDecimal(new Decimal(marketPriceTableInfo.primePriceMarkUpRate)).toFixed(2) : '',
      sellingPriceMarkUpRatePercentageInput: marketPriceTableInfo.isUsingSellingPrice ? decimalToPercentDecimal(new Decimal(marketPriceTableInfo.sellingPriceMarkUpRate)).toFixed(2) : '',
      deliveryPriceAdditionCd: marketPriceTableInfo.deliveryPriceAdditionCd,
      deliveryPriceAdditionAmount: marketPriceTableInfo.deliveryPriceAdditionAmount,
      isUsingDeliveryPrice: getUsingDeliveryPrice(marketPriceTableInfo.deliveryPriceAdditionCd),
      getDeliveryPrice: getDeliveryPriceCalculation(marketPriceTableInfo.deliveryPriceAdditionCd),      
      validation: true,
      isDelete: false,
      isChanged: true,
      isCustomerOrder: true,
      remarks: "",
      infoListIndex:
        insertIndex >= 0 ? insertIndex : marketPriceInfoList.length,
      displayOrder: insertDisplayOrder,
    };

    var newInfoList = [
      ...insertBeforeList,
      newMarketPriceInfo,
      ...insertAfterList,
    ];

    setMarketPriceInfoList(newInfoList);
    setChanged(true);
  };

  // 商品マスタ追加ダイアログを開く
  const openAddProductMasterDialog = (productData) => {
    setSelectedProductData(productData);
    setDialogMode(3);
  }

  // 商品明細マスタ追加ダイアログ
  const openAddProductDetailMasterDialog = (productData) => {
    setSelectedProductData(productData);
    setDialogMode(4);
  }

  const onClickDeleteProduct = (productData) => (event) => {
    setSelectedProductData(productData);
    setDialogMode(2);
  };

  // 商品を削除する処理
  const deleteProductData = () => {
    var deleteIndex = selectedProductData.infoListIndex;

    var newInfoList = [...marketPriceInfoList].map(
      (productData, productIndex) => ({
        ...productData,
        displayOrder:
          productIndex > deleteIndex &&
          productData.priceDetailTypeId == selectedProductData.priceDetailTypeId
            ? productData.displayOrder - 1
            : productData.displayOrder,
        isDelete: productIndex == deleteIndex || productData.isDelete,
        isChanged:
          (productIndex >= deleteIndex &&
            productData.priceDetailTypeId ==
              selectedProductData.priceDetailTypeId) ||
          productData.isChanged,
      })
    );

    setMarketPriceInfoList(newInfoList);
    setChanged(true);
  };

  const onClickConfirmMarketPrice = async (event) => {

    if (!await validateUpdateMarketPrice()) {
      return;
    }

    setUpdating(true);

    // ログインユーザID
    const loginUserId = getLoginUserInfo().userId

    // 更新処理
    let updateInfoList = marketPriceInfoList
      .filter((data) => !data.isDelete)
      .map((data) => ({
        marketPriceId: marketPriceTableInfo.marketPriceId,
        marketPriceDetailId: data.marketPriceDetailId,
        priceDetailTypeId: data.priceDetailTypeId,
        productId: data.productId,
        productDetailId: data.productDetailId,
        isOriginOther: data.isOriginOther,
        marketPrice: inputValueToInt(data.marketPriceInput),
        primePriceMarkUpRate: marketPriceTableInfo.isUsingSellingPrice ? percentDecimalToDecimal(inputValueToDecimal(data.primePriceMarkUpRatePercentageInput)) : null,
        sellingPriceMarkUpRate: marketPriceTableInfo.isUsingSellingPrice ? percentDecimalToDecimal(inputValueToDecimal(data.sellingPriceMarkUpRatePercentageInput)) : null,
        isCustomerOrder: data.isCustomerOrder,
        isShortage: data.isShortage,
        remarks: data.remarks,
        displayOrder: data.displayOrder,
        isDelete: data.isDelete,
        createdId: loginUserId,
        updatedId: loginUserId 
      }));

    const shippingDateInfo = getActualShippingDateInfo(
      shippingDateInput.dateFrom,
      shippingDateInput.dateTo,
      shippingDateInput.isValidInterval
    );

    const todayDate = getHyphenedDate();

    try {

      await postMarketPriceUpdateHistoryInfoAPI({
        marketPriceId:  marketPriceTableInfo.marketPriceId,
        marketPriceUpdateInfoList: updateInfoList,
        marketPriceHistoryDate: orderFormConfirmIsInit ? null: marketPriceTableInfo.marketPriceHistoryDate,
        createdId: loginUserId,
        updatedId: loginUserId,
        ...shippingDateInfo
      });

      navigate(SYSTEM_PATH_COMPANY + "/order_form_confirm", {
        state : getOrderFormConfirmLocationState(
          marketPriceTableInfo.marketPriceId, 
          shippingDateInfo.shippingDateFrom >= todayDate ? shippingDateInfo.shippingDateFrom : todayDate
        )
      });
    } catch (err) {
      alert(MSG_ERR_UNEXPECTED);
      setUpdating(false);
    }
  };

  // 市況価格表更新時バリデーション
  const validateUpdateMarketPrice = async () => {
    const marketPriceId = marketPriceTableInfo.marketPriceId;

    const shippingDateInfo = getActualShippingDateInfo(
      shippingDateInput.dateFrom,
      shippingDateInput.dateTo,
      shippingDateInput.isValidInterval
    );

    const todayDate = getHyphenedDate();    

    if (
      shippingDateInfo.shippingDateFrom < todayDate
      && (!shippingDateInfo.shippingDateTo || shippingDateInfo.shippingDateTo < todayDate)
    ) {
      alert("出荷日期間が過去です。指定をし直してください。");
      return false;
    }

    const marketPriceHistoryRes = await postMarketPriceSearchHistoryInShippingDates({
      marketPriceId,
      shippingDateFrom : (
        shippingDateInfo.shippingDateFrom >= todayDate ? shippingDateInfo.shippingDateFrom : todayDate
      ),
      shippingDateTo : shippingDateInfo.shippingDateTo || shippingDateInfo.shippingDateFrom
    });

    const marketPriceHistoryList = marketPriceHistoryRes.marketPriceTableInfoList;

    if (marketPriceHistoryList && marketPriceHistoryList.length == 0) {
      return true;
    }
    
    return window.confirm("出荷日期間内に別の市況価格表が存在します。\n上書きしますか?");
  }
  
  // 「戻る」押下
  const onClickReturn = (event) => {
    if (confirmWhenChanged(isChanged)) {
      navigate(SYSTEM_PATH_COMPANY + "/order_form_confirm", {
        state: {
          marketPriceId: marketPriceTableInfo.marketPriceId,
          marketPriceHistoryDate: orderFormConfirmIsInit ? null : marketPriceTableInfo.marketPriceHistoryDate,
        },
      });
    }
  }

  // 表示順を使って２つのデータを比較
  const compareDataByDisplayOrder = (data_a, data_b) => {
    return data_a.priceDetailTypeId - data_b.priceDetailTypeId;
  };

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "ArrowLeft" && e.altKey) {
        e.preventDefault();
        e.target.blur();
        if (tableTabPosition > 1) {
          setTableTabPosition((prevPosition) => prevPosition - 1);
        }
      } else if (e.key === "ArrowRight" && e.altKey) {
        e.preventDefault();
        e.target.blur();
        if (tableTabPosition < 3) {
          setTableTabPosition((prevPosition) => prevPosition + 1);
        }
      }
    },
    [tableTabPosition]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  // 価格表出力設定を取得する
  const getPriceTableSetting = (marketPriceTableInfo) => {
    if (marketPriceTableInfo) {
      return {
        unitPriceCd : marketPriceTableInfo.unitPriceCd,
        isUsingSellingPrice: marketPriceTableInfo.isUsingSellingPrice,
        isUsingDeliveryPrice: getUsingDeliveryPrice(marketPriceTableInfo.deliveryPriceAdditionCd),
        getDeliveryPrice: getDeliveryPriceCalculation(marketPriceTableInfo.deliveryPriceAdditionCd),
      }
    }

    return {};
    
  } 

  return (
    <CompanyTitledPage title="市況価格表　編集">
      <Grid container>
        <Typography sx={{ fontWeight: "bold", fontSize: 30 }}>
          {marketPriceTableInfo ? marketPriceTableInfo.marketPriceName : ""}
        </Typography>
      </Grid>

      <ErrorMessageBox messages={getErrorMessages()} />

      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <Typography sx={{ fontSize: 20, textAlign: "right" }}>
            出荷日 :
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <DateInput
            value={shippingDateInput.dateFrom}
            setValue={updateShippingDateInterval("dateFrom")}
          />
        </Grid>
        <Grid item xs="auto" display={shippingDateInput.isValidInterval ? "inherid" : "none"}>
          ～
        </Grid>
        <Grid item xs="auto" display={shippingDateInput.isValidInterval ? "inherid" : "none"}>
          <DateInput
            value={shippingDateInput.dateTo}
            setValue={updateShippingDateInterval("dateTo")}
          />
        </Grid>
        <Grid item xs="auto">
          <Switch
            checked={shippingDateInput.isValidInterval}
            onChange={onChangeShippingDateValidInterval}
          />
          期間で指定
        </Grid>
      </Grid>

      <Box marginTop={2} marginBottom={2}>
        <Grid container alignItems="baseline" spacing={2}>
          <Grid item xs>
            <Tabs value={tableTabPosition} onChange={handleChangeTab}>
              <Tab label="蔬菜" value={1} />
              <Tab label="果物" value={2} />
              <Tab label="スポット" value={3} />
            </Tabs>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="outlined"
              color="error"
              onClick={onClickAddProduct(null)}
            >
              商品追加
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={onClickConfirmMarketPrice}
              disabled={
                getErrorMessages().length > 0 || !marketPriceTableInfo || isUpdating
              }
            >
              市況価格表確定
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button
              size="medium"
              variant="outlined"
              onClick={onClickReturn}
            >
              戻る
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box>
        <PriceTableTabContent
          dataList={getPriceTabDataList(marketPriceInfoList, tableTabPosition)}
          updateDataList={updateDataList}
          onClickAddProduct={onClickAddProduct}
          onClickDeleteProduct={onClickDeleteProduct}
          tabPosition={tableTabPosition}
          priceTableSetting={getPriceTableSetting(marketPriceTableInfo)}
        />
      </Box>

      <AddProductDialog
        open={dialogMode === 1}
        tabPosition={tableTabPosition}
        productData={selectedProductData}
        onClose={onCloseDialog}
        addProduct={addProduct}
        priceTitle="市況価格"
        openAddProductMasterDialog={openAddProductMasterDialog}
        openAddProductDetailMasterDialog={openAddProductDetailMasterDialog}
        addedProductList={marketPriceInfoList.filter(
          (data) => !data.isDelete
        )}
      />

      <DeleteProductDialog
        open={dialogMode === 2}
        tabPosition={tableTabPosition}
        productData={selectedProductData}
        onCloseDialog={onCloseDialog}
        deleteProductData={deleteProductData}
      />

      <AddProductMasterDialog
        open={dialogMode === 3}
        onClose={onCloseDialog}
        productData={selectedProductData}
        openAddProductDialog={openAddProductDialog}
        openAddProductDetailMasterDialog={openAddProductDetailMasterDialog} 
      />

      <AddProductDetailMasterDialog
        open={dialogMode === 4}
        onClose={onCloseDialog}
        productData={selectedProductData}
        openAddProductDialog={openAddProductDialog}
      />
    </CompanyTitledPage>
  );
}
